import { useState, useEffect } from 'react';
import '../../index.css';
import apiService from '../../services/api.services';
import Navbar from '../../components/common/Navbar';
import { Row, Col, Container, Button,} from 'react-bootstrap';
import { MDBTable, MDBTableHead, MDBTableBody, MDBContainer, } from 'mdb-react-ui-kit';
import { useNavigate } from 'react-router-dom';

function CrmDetails() {

    useEffect(() => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.getAllCrmDetails(JWTtoken)
      .then(response => {
        setAllRows(response.data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
    }, []);

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    // Data
    const [allRows, setAllRows] = useState([]);
    const [error, setError] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 250; // Number of rows per page

    // Calculate total pages
    const totalPages = Math.ceil(allRows.length / rowsPerPage);

    // Calculate the rows to display on the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);

    const pageGroupSize = 5;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    if (loading) return <h1>Fetching CRM DATA...</h1>;
    if (error) return <h1>Error: {error.message}</h1>;

  return (
    <>
    <Navbar/>
       {/* <h1 className='headerRibbon'>CRM Details</h1> */}
            <MDBContainer className="pt-4 pb-5">
                <div style={styles.tableWrapper}>
                    <MDBTable align='middle' bordered hover>
                        <MDBTableHead className='table-info sticky-header'>
                            <tr>
                                <th scope='col'></th>
                                <th scope='col'>S.No</th>
                                <th scope='col'>CRM Number</th>
                                <th scope='col'>Customer Name</th>
                                <th scope='col'>Opportunity Name</th>
                                <th scope='col'>SalesPerson ID</th>
                                <th scope='col'>SalesPerson Name</th>
                                <th scope='col'>CRM Modification Date</th>
                                <th scope='col'>Preloading</th>
                                <th scope='col'>TopLine</th>
                                <th scope='col'>Bottomline</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {currentRows.map((row, index) => (
                                <tr key={index}>
                                    <th scope='row'></th>
                                    <td>
                                        <p className='text-muted mb-0'>{row.id}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.crmNumber}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.customerName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.opportunityName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.salesPersonID}</p> 
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.salesPersonName}</p> 
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.crmModificationDate}</p> 
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.preloading}</p> 
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.topline}</p> 
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.bottomline}</p> 
                                    </td>
                                </tr>
                            ))}
                        </MDBTableBody>
                    </MDBTable>
                </div>
                {/* Pagination Controls */}
                {/* <div style={styles.pagination}>
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    {[...Array(totalPages).keys()].map((number) => (
                        <button
                            key={number}
                            style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
                            onClick={() => handlePageChange(number + 1)}
                        >
                            {number + 1}
                        </button>
                    ))}
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div> */}

                <div style={styles.pagination}>
            <button
                style={styles.pageButton}
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>

            {startPage > 1 && (
                <>
                    <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
                    <span style={styles.ellipsis}>...</span>
                </>
            )}

            {[...Array(endPage - startPage + 1).keys()].map((index) => {
                const pageNum = startPage + index;
                return (
                    <button
                        key={pageNum}
                        style={{
                            ...styles.pageButton,
                            ...(pageNum === currentPage ? styles.activePageButton : {}),
                        }}
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                );
            })}

            {endPage < totalPages && (
                <>
                    <span style={styles.ellipsis}>...</span>
                    <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                </>
            )}

            <button
                style={styles.pageButton}
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
        </div>
            </MDBContainer>
    </>
  )
}

// const styles = {
//     tableWrapper: {
//         maxWidth: '200%',
//         overflowX: 'auto', // Enable horizontal scrolling
//         overflowY: 'auto', // Enable vertical scrolling
//         maxHeight: '450px', // Adjust the height to fit your needs
//         marginBottom: '10px',
//     },
//     pagination: {
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '5px',
//     },
//     pageButton: {
//         backgroundColor: '#007bff',
//         color: 'white',
//         border: 'none',
//         borderRadius: '4px',
//         padding: '5px 10px',
//         cursor: 'pointer',
//         outline: 'none',
//     },
//     activePageButton: {
//         backgroundColor: '#0056b3',
//     },
// };

const styles = {
        tableWrapper: {
            maxWidth: '200%',
            overflowX: 'auto', // Enable horizontal scrolling
            overflowY: 'auto', // Enable vertical scrolling
            maxHeight: '450px', // Adjust the height to fit your needs
            marginBottom: '10px',
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            flexWrap: 'wrap',
            marginTop: '1rem',
        },
        pageButton: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            cursor: 'pointer',
            outline: 'none',
        },
        activePageButton: {
            backgroundColor: '#0056b3',
        },
        ellipsis: {
            padding: '5px 10px',
            color: '#555',
        },
    };


// CSS styles
const stickyHeaderStyles = `
.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; // Ensures the header is on top
    background-color: #343a40; // Match the table header color
    color: white; // Text color for header
}
`;

// Add the sticky header styles to the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = stickyHeaderStyles;
document.head.appendChild(styleSheet);

export default CrmDetails
